export const deleteAllCookies = () => {
  let cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) { deleteCookie(cookies[i].split('=')[0]) }
}

export const setCookie = (name, value, expirydays) => {
  let d = new Date()
  d.setTime(d.getTime() + (expirydays * 24 * 60 * 60 * 1000))
  let expires = 'expires=' + d.toUTCString()
  document.cookie = name + '=' + value + '; ' + expires
}

export const deleteCookie = name => {
  setCookie(name, '', -1)
}

export default {
  methods: {
    deleteAllCookies,
    setCookie,
    deleteCookie
  }
}
